import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Breakpoint"),
    /*#__PURE__*/_createElementVNode("th", null, "Min"),
    /*#__PURE__*/_createElementVNode("th", null, "Max"),
    /*#__PURE__*/_createElementVNode("th", null, "Can Use in Media Query"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode(" Can Use in "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://vuetifyjs.com/en/components/grids/#usage",
        target: "_blank"
      }, "Grid")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, "xs", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "0", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "374px", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "375", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "375px", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "575px", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "sm", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "576px", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "624px", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "625", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "625px", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "767px", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "md", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "768px", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "1023px", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "lg", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "1024px", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "1239px", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "xl", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, "1240px", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "1439px", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "xxl", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "1440px", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "1919px", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, "1920", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "1920px", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "∞", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "style-guide--breakpoints" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-close",
                      color: "error"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-close",
                      color: "error"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-check",
                      color: "success"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_icon, {
                      icon: "ep-icon-close",
                      color: "error"
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}